import { useCallback, useEffect, useState } from 'react'
import { ADDITIONAL_SALES_THEME_VIEW_TIMEOUT } from '../../utils/constantes'
import { getPictoByThemeId } from '../../utils/pictos'
import { THEME_DATA } from '../../utils/constantes'
import { usePreloadedImage } from '../../hooks/PreloadedImage'

const clampIndex = (i, len) => Math.min(Math.max(0, i), Math.max(0, len - 1))

const AdditionalSalesThemeSplashScreen = ({ themeId, onClose }) => {
  const [isVisible, setIsVisible] = useState(false)
  const galleryImages = usePreloadedImage(themeId)

  const [fullIndex, setFullIndex] = useState(() => clampIndex(0, galleryImages.length))

  const themeData = THEME_DATA[themeId]

  const closePopup = useCallback(() => {
    setIsVisible(false)
    setTimeout(() => onClose(), 500)
  }, [onClose])

  useEffect(() => {
    if (themeId) {
      setIsVisible(true)
    } else {
      setIsVisible(false)
    }
  }, [themeId])

  useEffect(() => {
    if (!isVisible) return undefined
    setFullIndex(0)

    const timeout = setTimeout(() => {
      closePopup()
    }, ADDITIONAL_SALES_THEME_VIEW_TIMEOUT)

    return () => clearTimeout(timeout)
  }, [closePopup, isVisible, themeId])

  if (!themeId && !isVisible) return null

  const Picto = getPictoByThemeId(themeId)

  return (
    <div
      className="additionalSalesThemeSplashScreen hero"
      style={{
        transform: isVisible ? 'scale(1)' : 'scale(0.95)',
        opacity: isVisible ? 1 : 0,
        '--left': themeData?.color || '#ec6e3e',
        '--right': themeData?.gradientRight || themeData?.color || '#17152d',
      }}
      onClick={closePopup}
    >
      <div id="title">
        <Picto className="picto"></Picto>
        <h1>{themeData?.fullName}</h1>
      </div>
      <div id="gallery">
        {galleryImages.map((src, index) => (
          <img
            key={index}
            src={src}
            alt=""
            onClick={(e) => {
              e.stopPropagation()
              setFullIndex(index)
            }}
            style={{
              flex: fullIndex === index ? '1 1 0' : '0 0 230px',
              maxWidth: fullIndex === index ? '800px' : '230px',
            }}
          />
        ))}
      </div>
    </div>
  )
}

export default AdditionalSalesThemeSplashScreen
